// extracted by mini-css-extract-plugin
export default {"optionCard":"option-card_optionCard__oNgbV","selected":"option-card_selected__cFM-c"};